import { OpenMBStatus } from 'models/open_mb'

export const OPEN_MB_STATUS_TEXT: Record<OpenMBStatus, string> = {
  [OpenMBStatus.in_process]: 'В очереди',
  [OpenMBStatus.waiting]: 'В работе',
  [OpenMBStatus.error]: 'На уточнении',
  [OpenMBStatus.denied]: 'Отклонено',
  [OpenMBStatus.given]: 'Закрыто',
  [OpenMBStatus.notfound]: 'Не найден',
}
